import {Component, Inject, Input, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {NotificationService} from 'src/app/core/services/notification.service';
import {UserService} from 'src/app/core/services/user.service';
import { formConstant } from '../../../../../../config';
import {CityService} from '../../../../../core/services/city.service';
import {b2bclientsService} from '../../../services/b2bclients.service';
import {LocalStorageService} from 'src/app/core/services/local-storage.service';
import { cellPhoneValidatorNew, emailValidator } from 'src/app/core/helpers/helpers.function';
import {ConstantService} from 'src/app/core/services/constant.service';
import {ICountry, IState} from 'src/app/core/models/country.interface';

export const validatorConfirmPassword = (form: AbstractControl): ValidationErrors | null => {
    const password = form.get('password');
    const confirmPassword = form.get('confirmPassword');
    if (confirmPassword.value !== password.value) {
        confirmPassword.setErrors({notSame: true})
    }
    return null;
}

@Component({
    selector: 'eci-b2bclients-access-popup',
    templateUrl: './b2bclients-access-popup.component.html',
    styleUrls: ['./b2bclients-access-popup.component.scss']
})
export class B2bclientsAccessPopupComponent implements OnInit {
    @Input() customerId: number;
    @Input() countries: ICountry[] = [];
    formGroup: FormGroup;
    info: any;
    isUpdateMode: boolean = false;
    isEnableOther: boolean = false;
    title: string = 'Add B2B Clients';
    states: IState[] = [];
    cities: any[] = [];
    searchCountry: FormControl = new FormControl('');
    searchState: FormControl = new FormControl('');
    searchCity: FormControl = new FormControl('');
    searchPaymentsTerms: FormControl = new FormControl('');
    companyNameMaxlemgth = formConstant.textFieldMaxLength30;
    paymentsterms = [
        {name: 'Upon delivery'},
        {name: '50% prepaid, 50% upon delivery'},
        {name: 'Net +30'},
        {name: 'Net +60'},
        {name: 'Other'}
    ];

    constructor(
        private b2bclientsServices: b2bclientsService,
        private notify: NotificationService,
        private localStorageSvc: LocalStorageService,
        private constSvc: ConstantService,
        private citySvc: CityService,
        public dialogRef: MatDialogRef<B2bclientsAccessPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public userSvc: UserService,
        private fb: FormBuilder
    ) {
    }

    ngOnInit(): void {
        this.initializeForm();
        this.subscribeOnCountries();
        if (this.countries.length === 0) {
            this.getListOfCountries();
        } else {
            this.updateCountry();
        }
    }

    private initializeForm(): void {
        let countryIso2 = 'us';
        if (this.countries.length > 0 && this.info?.phoneCode) {
            countryIso2 = this.getDialCode(this.info?.phoneCode);
        }
        this.formGroup = new FormGroup({
            firstName: new FormControl(
                this.info?.firstName || '',
                [
                    Validators.required,
                    Validators.maxLength(formConstant.textFieldMaxLength30),
                    Validators.pattern(/^[A-Za-z0-9 ]+$/)
                ]),
            lastName: new FormControl(
                this.info?.lastName || '',
                [
                    Validators.required,
                    Validators.maxLength(formConstant.textFieldMaxLength30),
                    Validators.pattern(/^[A-Za-z0-9 ]+$/)
                ]),
            vatNumber: new FormControl(
                this.info?.vatNumber, [
                    Validators.required,
                    Validators.minLength(formConstant.VATMinLength),
                    Validators.maxLength(formConstant.VATMaxMinLength),
                    Validators.pattern(/^[A-Za-z0-9]+$/),
                ]),
            phoneCode:  new FormControl(
                this.info?.phoneCode || '1', [
                    Validators.required,
                ]),
            countryIso2: new FormControl(countryIso2),
            mobileNumber: new FormControl(
                this.info?.mobileNumber, [cellPhoneValidatorNew()]),
            email: new FormControl(
                this.info?.email || '', [
                    Validators.required,
                    Validators.email,
                    emailValidator()
                ]),
            password: new FormControl(
                this.isUpdateMode ? null : '',
                this.isUpdateMode ? null : [
                    Validators.required,
                    Validators.minLength(formConstant.passwordMinLength),
                    Validators.pattern(/^((?=.*\d)(?=.*[a-z])(?=.*[A-Z]))[0-9a-zA-Z_@./#$^*%&+-]{8,}$/)
                ]),
            confirmPassword: new FormControl(
                this.isUpdateMode ? null : '',
                this.isUpdateMode ? null : [Validators.required],
            ),
            companyName: new FormControl(
                this.info?.companyName || '', [
                    Validators.required,
                    Validators.maxLength(this.companyNameMaxlemgth),
                    Validators.pattern(/^[A-Za-z0-9 ]+$/)
                ]),
            country: new FormControl(
                null,
                [
                    Validators.required,
                ]),
            state: new FormControl(
                null,
                [
                    Validators.required,
                ]),
            city: new FormControl(
                this.info?.address?.city,
                [
                    Validators.required,
                ]),
            address: new FormControl(
                this.info?.address?.name,
                [
                    Validators.required,
                ]),
            zipCode: new FormControl(
                this.info?.address?.zipCode,
                [
                    Validators.required,
                ]),
            paymentsTerms: new FormControl(
                this.info?.paymentsTerms,
                [
                    Validators.required,
                ]),
            remark: new FormControl(
                this.info?.remark || '', [
                    Validators.maxLength(100)
                ]),
        }, {validators: [validatorConfirmPassword]});
    }

    private updateCountry(): void {
        const selectedCountry = this.countries.find((item) => item.id == this.info?.address?.countryId);
        if (selectedCountry) {
            this.formGroup.get('country').setValue(selectedCountry.id);
        }
    }

    paymentsTerms(selectedItem: any) {
        if (selectedItem.value === 'Other') {
            this.isEnableOther = true;
            this.formGroup.addControl('otherPaymentsTerms', new FormControl(this.info?.otherPaymentsTerms || '', [Validators.required, Validators.maxLength(100)]));
        } else {
            this.isEnableOther = false;
            this.formGroup.removeControl('otherPaymentsTerms');
        }
    }

    getListOfCountries(
        page: number = 1,
        q: string = '',
        limit: number = 1000,
        withTaxRate: boolean = false,
    ): void {
        this.constSvc.getAvailableCountriesForScroll(page, limit, false, q, withTaxRate).subscribe(data => {
            if (data) {
                this.countries = data.items;
                this.updateCountry();
            }
        });
    }

    subscribeOnCountries() {
        this.formGroup?.get('country')?.valueChanges.subscribe(countryId => {
            if (countryId) {
                const country = this.countries?.find(c => c.id === countryId);
                this.getCitiesByCountryId(countryId);
                this.constSvc.getAvailableStatesById(country.code).subscribe(states => {
                    if (states) {
                        this.states = states;
                        let st = this.states.find(el => el.id === this.info?.address?.stateId);
                        this.formGroup.get('state').setValue(st ? st.id : states[0]?.id || null);
                    } else {
                        this.formGroup.get('state').setValue(null);
                    }
                });
            }
        });
    }

    getCitiesByCountryId(countryID: string | number): void {
        if (countryID) {
            this.citySvc.getAllByCountryId(countryID).subscribe(cities => {
                if (cities) {
                    this.cities = cities;
                    let st = this.cities.find(el => el.id === this.info?.address?.city);
                    this.formGroup?.get('city')?.setValue(st ? st.id : cities[0]?.id || null);
                } else {
                    this.formGroup?.get('city')?.setValue(null);
                }
            });
        }
    }

    public onSubmit(): void {
        if (this.formGroup.invalid) {
            this.formGroup.markAllAsTouched();
            return;
        }
        if (!this.isUpdateMode) {
            this.b2bclientsServices.createB2bClient(
                {
                    ...this.formGroup.value,
                    companyId: this.customerId ? this.customerId : this.userSvc.company.id,
                }
            ).subscribe(res => {
                this.notify.showSuccessMessage('Added successfully');
                this.dialogRef.close();
            }, err => {
                this.notify.showValidationError(err);
            })
        } else {
            this.b2bclientsServices.updateB2bClient(
                {
                    ...this.formGroup.value,
                    id: this.info.id,
                    companyId: this.customerId ? this.customerId : this.userSvc.company.id,
                }
            ).subscribe(res => {
                this.notify.showSuccessMessage('Updated successfully');
                this.dialogRef.close();
            }, err => {
                this.notify.showError(err.message);
            })
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    getFlagClass(id) {
        const country = this.countries?.find(c => c.id === id);
        return `iti__${country?.code.toLowerCase()}`;
    }

    private getDialCode(phoneCode): string {
        const country = this.countries?.find((c) => c.phoneCode === phoneCode);
        return country?.code.toLowerCase();
    }

    getCountryNameByCode(id) {
        return this.countries?.find(c => c.id === id)?.name;
    }

    public hasErrors(error): void {
        if (!error) {
            this.formGroup?.controls.mobileNumber.setErrors({'incorrect': !error});
        } else {
            this.formGroup?.controls.mobileNumber.setErrors(null);
        }
    }

    public onCountryChange(phoneCode): void {
        this.formGroup?.controls?.countryIso2.setValue(phoneCode.iso2);
        this.formGroup?.controls?.phoneCode.setValue(`+${phoneCode.dialCode}`);
    }

}
